export const MV_MOVIE = {
  init: function (elements) {
    const v = $('#load_movie')
    const sp = '/wp-content/themes/dawing/assets/img/top/hero_mv01_sp.mp4'
    const pc = '/wp-content/themes/dawing/assets/img/top/hero_mv01.mp4'
    let windowWidth = parseInt(document.body.clientWidth)
    const replaceWidth = 768
    let timer = false

    function videoSwitch() {
      // 要素がなければ終了
      if (v.length === 0) {
        return
      }
      // ウィンドウサイズが768px以上であれば_pcを再生
      if (windowWidth >= replaceWidth) {
        v.attr('src', pc)
      } else {
        // ウィンドウサイズが768px未満であれば_spを再生
        v.attr('src', sp)
      }

      v.get(0).play()
    }
    videoSwitch()

    $(window).on('orientationchange resize', function () {
      const resizeWidth = parseInt(document.body.clientWidth)
      if (windowWidth !== resizeWidth) {
        if (timer !== false) clearTimeout(timer)
        timer = setTimeout(function () {
          videoSwitch()
          windowWidth = resizeWidth
        }, 200)
      }
    })
  },
}
